import { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { VehicleCard } from "@app/components";
import { useResponsive } from "@app/hooks";

const ProductList = ({ name, vehicles, isScrollable = true }: any) => {
  const navigate = useNavigate();
  const isMobile = useResponsive("down", "md");
  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);

  return (
    <>
      <Box
        mt={3}
        width="100%"
        alignItems={"center"}
        display={"flex"}
        flexDirection={"column"}
      >
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          width={"96%"}
          alignItems={"center"}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            {name}
          </Typography>
          <Button
            onClick={() => {
              navigate(PATH_DASHBOARD.productListPage);
            }}
            variant="outlined"
          >
            {Strings.button.seeAll}
          </Button>
        </Stack>

        {isScrollable ? (
          <Box
            sx={{
              overflowX: "auto",
              width: "96%",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Stack
              direction="row"
              gap={2}
              sx={{ minWidth: "max-content", p: 1 }}
            >
              {vehicles?.map((item: any, index: any) => (
                <VehicleCard
                  key={index}
                  vehicle={item}
                  selectedCardId={selectedCardId}
                  onSelect={setSelectedCardId}
                  onViewDetails={() =>
                    navigate(`${PATH_DASHBOARD.productDetail}/${item.id}`)
                  }
                />
              ))}
            </Stack>
          </Box>
        ) : (
          <Box
            sx={{
              width: { xs: "100%", md: "80%" },
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              p: 1,
              justifyContent: "center",
            }}
          >
            {vehicles?.map((item: any, index: any) => (
              <VehicleCard
                key={index}
                vehicle={item}
                selectedCardId={selectedCardId}
                onSelect={setSelectedCardId}
                onViewDetails={() =>
                  navigate(`${PATH_DASHBOARD.productDetail}/${item.id}`)
                }
              />
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ProductList;
